import { type TranslationTree } from '@/i18n/types';

export const messages = {
  passwordRequired: 'Senha é obrigatória',
  passwordPattern:
    'Senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial',
  tooLong: 'Texto longo demais',
  postalCodeInvalid: 'Digite um CEP válido',
  streetRequired: 'A rua é obrigatória',
  cityRequired: 'A cidade é obrigatória',
  stateRequired: 'Selecione a UF',
} satisfies TranslationTree;
